<ul class="navbar-nav-list">
  <ng-content></ng-content>
</ul>
